module.exports = __webpack_public_path__ + "img/GiveUpSmiley.db089f1f.svg";